'use client';

import { useReportWebVitals } from 'next/web-vitals';
export function WebVitals() {
  const isDev = process.env.NODE_ENV !== 'production' || false;
  useReportWebVitals(metric => {
    if (!isDev) return;
    switch (metric.name) {
      case 'LCP':
      case 'CLS':
      case 'INP':
      case 'FCP':
        // eslint-disable-next-line no-console
        console.log(metric);
    }
  });
  return null;
}